import React from 'react'
import { AccordionCheckbox, AccordionCheckboxProps } from './accordion-checkbox'
import { AccordionDefault, AccordionProps } from './accordion-default'

type DefaultAccordion = AccordionProps & {
  variant?: 'default'
  href?: string
}

type CheckboxAccordion = AccordionCheckboxProps & {
  variant: 'checkbox'
}
type AccordionType = DefaultAccordion | CheckboxAccordion

export const Accordion = (props: AccordionType) => {
  const { variant } = props
  return (
    <>
      {(!variant || variant === 'default') && <AccordionDefault {...props} />}

      {variant === 'checkbox' && <AccordionCheckbox {...props} />}
    </>
  )
}
